/**
 * MessageBubble Component - Displays an individual chat message
 */

import '../styles/MessageBubble.css';

// Helper function to safely get a string value (prevents rendering objects)
const safeString = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  return fallback;
};

const MessageBubble = ({ message, isOwnMessage, showTimestamp = true }) => {
  // Defensive check for message object
  if (!message) {
    console.error('MessageBubble: message is null or undefined');
    return null;
  }

  const formatMessageTime = (timestamp) => {
    if (!timestamp) return '';

    try {
      const now = Date.now();
      const diff = now - timestamp;
      const date = new Date(timestamp);

      // If message is from today, show time only
      const today = new Date();
      const isToday = date.toDateString() === today.toDateString();

      if (isToday) {
        return date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      }

      // If message is from yesterday
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const isYesterday = date.toDateString() === yesterday.toDateString();

      if (isYesterday) {
        return 'Yesterday ' + date.toLocaleTimeString('en-US', {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true
        });
      }

      // Otherwise, show full date
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      }) + ' ' + date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      console.error('Error formatting message time:', error);
      return '';
    }
  };

  return (
    <div className={`message-bubble-container ${isOwnMessage ? 'own-message' : 'other-message'}`}>
      <div className="message-bubble">
        <div className="message-content">
          {safeString(message?.message, '[No content]')}
        </div>

        {showTimestamp && (
          <div className="message-metadata">
            <span className="message-time">{formatMessageTime(message.timestamp)}</span>
            {isOwnMessage && message.read && (
              <span className="message-read-indicator" title="Read">✓✓</span>
            )}
            {isOwnMessage && !message.read && (
              <span className="message-sent-indicator" title="Sent">✓</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageBubble;
